import {
  SAVE_BRAND_YARAGH_LIST_OLGU,
  SAVE_COLOR_LIST,
  SAVE_DASTE_PROFILE_LIST_WITH_TYPE_STRUCT,
  SAVE_DASTE_PROFILE_LIST_TYPE,
  SAVE_FRAME_LIST,
  SAVE_ALL_OLGU_DATA,
  SAVE_SHISHE_GROUP_LIST,
  SAVE_SHISHE_LIST,
  SAVE_TORI_LIST,
  SAVE_TYPE_COLOR_LIST_OLGU,
  SET_DATA_OLGU_FOR_EDIT,
  ACTION_GET_OLGU_RELATION,
  OLGU_DATA_SEARCH,
  GET_OLGU_AGAIN,
} from "Stores/actionTypes";
import { updateObject } from "./utility";

const initialState = {
  dasteProfileListWithTypeStruct: [],
  frameList: [],
  typeColorList: [],
  colorList: [],
  brandYaraghList: [],
  toriList: [],
  shisheGroupList: [],
  shisheList: [],
  allOlguData: [],
  allOlguDataPagination: { Limit: 5, Page: 1, Total: 0 },
  dasteProfileListWithType: [],
  allOlguDataSearch: null,
  olgEdit: [
    {
      NameTemplate: null,
      IdGlass: 0,
      IdNet: 0,
      IdFitting: 0,
      FrameList: [],
      IdFrameList: null,
      SashList: [],
      IdSashList: null,
      SashDoorList: [],
      IdSashDoorList: null,
      MolionList: [],
      IdMolionList: null,
      OverhungList: [],
      IdOverhungList: null,
      ProfileKomakiList: [],
      IdProfileKomakiList: null,
      PaneliList: [],
      IdPaneliList: null,
      Zehvar1List: [],
      IdZehvar1List: null,
      Zehvar2List: [],
      IdZehvar2List: null,
      Zehvar3List: [],
      IdZehvar3List: null,
      MolionFrameList: [],
      IdMolionFrameList: null,
      MolionKatibehList: [],
      IdMolionKatibehList: null,
      InterlockList: [],
      IdInterlockList: null,
      ConectorSashList: [],
      IdConectorSashList: null,
      ZehvarBaranList: [],
      IdZehvarBaranList: null,
      CoverWaterList: [],
      IdCoverWaterList: null,
      getAllOlguAgain: false
    },
  ],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_DASTE_PROFILE_LIST_TYPE:
      return updateObject(state, {
        dasteProfileListWithType: action.dasteProfileListWithType,
      });
    case GET_OLGU_AGAIN:
      return updateObject(state, {
        getAllOlguAgain: action.data,
      });
    case OLGU_DATA_SEARCH:
      return updateObject(state, {
        allOlguDataSearch: action.allOlguDataSearch,
      });
    case SAVE_ALL_OLGU_DATA:
      return updateObject(state, {
        allOlguData: action.allOlguData,
        allOlguDataPagination: action.allOlguDataPagination,
      });
    case SAVE_SHISHE_LIST:
      return updateObject(state, { shisheList: action.shisheList });
    case SAVE_SHISHE_GROUP_LIST:
      return updateObject(state, { shisheGroupList: action.shisheGroupList });
    case SAVE_TORI_LIST:
      return updateObject(state, { toriList: action.toriList });
    case SAVE_BRAND_YARAGH_LIST_OLGU:
      return updateObject(state, { brandYaraghList: action.brandYaraghList });
    case SAVE_COLOR_LIST:
      return updateObject(state, { colorList: action.colorList });
    case SAVE_TYPE_COLOR_LIST_OLGU:
      return updateObject(state, { typeColorList: action.typeColorList });
    case SAVE_FRAME_LIST:
      return updateObject(state, { frameList: action.frameList });
    case SAVE_DASTE_PROFILE_LIST_WITH_TYPE_STRUCT:
      return updateObject(state, {
        dasteProfileListWithTypeStruct: action.dasteProfileListWithTypeStruct,
      });
    case SET_DATA_OLGU_FOR_EDIT:
      return updateObject(state, { olgEdit: action.getOlg });
    case ACTION_GET_OLGU_RELATION:
      return updateObject(state, { dataRelation: action.data });

    default:
      return state;
  }
};
export default reducer;
